<template>
  <div v-if="items.length !== 0">
    <section class="coming-webinars">
      <div class="container">
        <div class="section-title-header">
          <h2 class="main-title">{{ title }}</h2>
          <div class="coming-webinars__link-wrap" v-if="linkToAll">
            <a :href="`/${lang}/webinars/`" class="link-arrow">Все вебинары</a>
          </div>
        </div>
        <ul class="coming-webinars__list">
          <webinar-ru-card
            v-for="item in items"
            :key="item.id"
            :title="item.title"
            :description="item.description"
            :dateExpire="getDate(item.dateExpire)"
            :time="item.time"
            :filePath="item.filePath"
            :soon="item.soon"
            :lang="lang"
            :speakers="item.speakers"
            :coming="new Date(item.dateExpire) < new Date()"
            :badge="item.badge"
          ></webinar-ru-card>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import WebinarRuCard from "./cards/WebinarRuCard";

export default {
  name: 'WebinarsListRu',
  components: {
    WebinarRuCard
  },
  props: {
    coming: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    linkToAll: Boolean
  },
  data() {
    return {
      items: [],
      lang: ''
    }
  },
  mounted() {
    this.lang = this.getCurrentLang();
    this.getWebinars();
  },
  methods: {
    getWebinars() {
      fetch(`/${this.lang}/webinars/index.json`)
        .then((response) => response.json())
        .then((data) => {
          const webinars = data.data;

          if(this.coming) {
            this.items = webinars.filter((w) => new Date(w.dateExpire) > new Date()).sort((a, b) => a.id - b.id);
          } else {
            this.items = webinars.filter((w) => new Date(w.dateExpire) < new Date()).sort((a, b) => b.id - a.id);
          }
        });
    },
    getCurrentLang() {
      return window.location.pathname.split('/').filter((i) => i !== '')[0];
    },
    getDate(date) {
      const datetime = new Date(date);
      return datetime.toLocaleDateString('ru-RU', {month: 'long', day: '2-digit'});
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WebinarsListRu.vue